module.exports = __webpack_public_path__ + "static/img/fredericton1.503f4e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/fredericton1.jpg
// module id = 87
// module chunks = 9